import * as React from "react";
import { useEffect, useState } from "react";
import polarLogo from "../../../assets/images/polar.svg";
import bellIcon from "../../../assets/images/bell.png";
import settingsIcon from "../../../assets/images/settings.png";
import deleteIcon from "../../../assets/images/trash-2.png";
import phoneIcon from "../../../assets/images/Phone.png";
import emailIcon from "../../../assets/images/Email.png";
import briefcaseIcon from "../../../assets/images/fcaseicone.png";
import whatsappIcon from "../../../assets/images/WhatsApp.png";
import editIcon from "../../../assets/images/edit.png";
import { updateCorporate, getCorporateForSAASAdmin,createUser,mapKitForProject } from "../../polar-SAAS-Components/api-helper";
import AddUserPopup from "../../popup/AddUserPopup";
import CreateProjectPopup from "../../popup/CreateProjectPopup";
import { createProject, loadGoogleMaps } from "src/services/corporateService";
import AddKitModal from "src/app/popup/AddKitModal";
import { KitData,UserData } from "src/app/polar-SAAS-Components/models-new";
import { environment } from "src/environments/environment";

// Theme configuration
const theme = {
  fontFamily: "Poppins, sans-serif",
  colors: {
    primary: "#2A7CED",
    primaryHover: "#2A7CED",
    text: "#111827",
    lightText: "#6B7280",
    border: "#E5E7EB",
    borderHover: "#D1D5DB",
    backgroundHover: "#F9FAFB",
    error: "#EF4444",
    white: "#FFFFFF",
    modalOverlay: "rgba(0, 0, 0, 0.5)",
    logoText: "#111827",
    logoSubtext: "#6B7280",
    dashedBorder: "#93C5FD",
    plusIcon: "#2A7CED",
    sectionBorder: "#E5E7EB",
  },
  spacing: {
    small: "8px",
    medium: "16px",
    large: "24px",
    xlarge: "32px",
    xxlarge: "40px",
  },
  shadows: {
    modal: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    button: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    buttonHover: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
    header: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
  },
  sizes: {
    logoContainer: { width: "120px", height: "40px" },
    formContainer: { maxWidth: "600px" },
    modal: { maxWidth: "600px" },
    button: { minWidth: "120px" },
  },
  transitions: {
    default: "all 0.15s ease",
    hover: "all 0.2s ease",
  },
};

// Reusable style objects with consistent Poppins font
const baseLabelStyles: React.CSSProperties = {
  display: "block",
  textAlign: "left",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
  fontSize: "14px",
  color: "theme.colors.text",
  marginBottom: theme.spacing.small,
};

const baseInputStyles: React.CSSProperties = {
  width: "100%",
  padding: "6px 12px",
  border: `1px solid ${theme.colors.border}`,
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 400,
  outline: "none",
  transition: theme.transitions.default,
  fontFamily: "Poppins, sans-serif",
  boxSizing: "border-box",
  color: theme.colors.text,
};

const baseButtonStyles: React.CSSProperties = {
  padding: "10px 16px",
  borderRadius: "4px",
  fontWeight: 500,
  fontSize: "14px",
  cursor: "pointer",
  transition: theme.transitions.default,
  minWidth: theme.sizes.button.minWidth,
  fontFamily: "Poppins, sans-serif",
};

const errorTextStyles: React.CSSProperties = {
  color: theme.colors.error,
  fontSize: "12px",
  marginTop: "4px",
  display: "block",
  fontFamily: "Poppins, sans-serif",
};


export const useNavigate = () => {
  return (path: string) => {
    window.location.href = path;
  };
};



const PolarInterface = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [showCorporateCard, setShowCorporateCard] = useState(false);
  const [createdUsers, setCreatedUsers] = useState<UserData[]>([]);
  const [createdKits, setCreatedKits] = useState<KitData[]>([]);
  const [isAddUserDisabled, setIsAddUserDisabled] = useState(true);
  const [isAddKitDisabled, setIsAddKitDisabled] = useState(true);
  const [username,setUsername]=useState('User')

  // Corporate form states
  const [corporateName, setCorporateName] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [brc, setBrc] = useState('');
  const [contactAddress, setContactAddress] = useState('');
  const [showAddUserPopup, setShowAddUserPopup] = useState(false);
  const [showAddProjectPopup, setShowAddProjectPopup] = useState(false);
  const [showAddKitPopup, setshowAddKitPopup] = useState(false);
  const [createdProjects,setCreatedProjects]=useState([]);
  const [errCreatingUser,setErrorCreatingUser]=useState('');
  const [errCreatingProject,setErrCreatingProject]=useState('');
  const [errCreatingKit,setErrCreatingKit]=useState('');

  const [showMapModal, setShowMapModal] = useState(false);
  const [myLoc, setMyLoc] = useState<{ lat: number; lng: number } | null>(null);
  const mapRef = React.useRef<HTMLDivElement>(null);


    useEffect(() => {
      loadGoogleMaps(environment.googleMapKey).catch(function (e) {
        console.error("Failed to load Google Maps", e);
      });
    }, []);
  
    React.useEffect(() => {
    document.body.style.overflow = showMapModal ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showMapModal]);
  
  
  
    useEffect(() => {
      console.log('open map',showMapModal,myLoc,mapRef.current);
      if (!showMapModal || !myLoc || !mapRef.current) return;
      const map = new google.maps.Map(mapRef.current, {
        center: { lat: myLoc.lat, lng: myLoc.lng },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });
      new google.maps.Marker({
        position: { lat: myLoc.lat, lng: myLoc.lng },
        map: map,
        title: "You are here",
      });
    }, [showMapModal, myLoc]);
  
  const handleCreateUser = async(userData: UserData) => {
    try{
    const response=await createUser(userData);
       console.log("New user created:", response);
    if(response.status==200){
      setCreatedUsers([...createdUsers,response.data.content])
      setShowAddUserPopup(false)
    }
    else{
      console.log('error createing user ',response.data)
    }
  }
  catch(err){
        console.log('error',err,err.response)
          setErrorCreatingUser(err.response.data.message||'Error creating user');

  }
  finally{
    setIsAddKitDisabled(false); 
  }

  };

  const handleCreateProject = async(projectData:any) => {
    console.log("New project created:", projectData);
    try {
      const response = await createProject(projectData);
      console.log(response);
      if (response.error) {
        console.error('Error creating project:', response.error);
        return;
      }
      if (response && response.response.status === 200) {
        setCreatedProjects([...createdProjects, projectData]);
        setIsAddUserDisabled(false);
      } else {
        console.error('Error creating project');
      }
    } catch (err) {
      console.log('error',err,err.response)
      setErrCreatingProject(err.response.data.message||'Error creating project');
    }
    finally{

    }
  };

  const handleCreateKit = async(kitData: KitData) => {
    try{
    const response=await mapKitForProject(kitData);
    console.log("New kit created:", response);
    setCreatedKits([...createdKits, kitData]);
    }
    catch(err){
      console.log('error',err,err.response)
      setErrCreatingKit(err.response.data.message||'Error creating entity');
    }
  };
  const [corporateId,setCorporateId]=useState('')
  // Error states
  const [errors, setErrors] = useState({
    corporateName: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null,
    brc: null,
    contactAddress: null,
  });
  
  React.useEffect(() => {

  const fetchData = async () => {
    try {
      const corporateForUser = await getCorporateForSAASAdmin();
      const corporate = corporateForUser.data.content[0];
  

      if (!corporate) {
        console.log('azure subscription configuration failed');
        return};

      setCorporateId(corporate.id);
      setContactEmail(corporate.contactEmail);
      console.log('corporate ',corporate)
      // Check if corporate is configured
      if (!((corporate.name == null || corporate.name === '') && corporate.status === "INACTIVE")) {
        
        setShowCorporateCard(true);
      }
    } catch (error) {
      console.log("Failed to fetch corporate info", error);
    }
  };
  let username=localStorage.getItem('USERNAME');
  if(username&&username.length>0){
  setUsername(username);
  }
  fetchData(); // call the async wrapper
}, []);

  const handleSubmit = async () => {
    // Validate corporate form
    const newErrors = {...errors};
    let isValid = true;
    
    if (!corporateName.trim()) {
      newErrors.corporateName = 'Corporate name is required';
      isValid = false;
    }
    if (!contactName.trim()) {
      newErrors.contactName = 'Contact name is required';
      isValid = false;
    }
    if (!contactEmail.trim()) {
      newErrors.contactEmail = 'Contact email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)) {
      newErrors.contactEmail = 'Invalid email format';
      isValid = false;
    }
    if (!contactPhone.trim()) {
      newErrors.contactPhone = 'Contact phone is required';
      isValid = false;
    }
    if (!brc.trim()) {
      newErrors.brc = 'BRC is required';
      isValid = false;
    }
    if (!contactAddress.trim()) {
      newErrors.contactAddress = 'Contact address is required';
      isValid = false;
    }
    
    setErrors(newErrors);
    if (!isValid) return;

    const  corporateData={
      "name":corporateName,
      "contactPhoneNumber":contactAddress,
      "contactName":contactName,
      "contactEmail":contactEmail,
      "contactAddress":contactAddress,
      "brc":brc,
      "status":"ACTIVE"
     } 

  try {


    const response = await updateCorporate(corporateData, corporateId);
    console.log("Update successful:", response.data);
    console.log('Form submitted');
    setShowCorporateCard(true);
  }
  catch(error){
    console.log(error)
  }
  };

  const handleBack = () => {
    setShowCorporateCard(false);
  };

  const handleAddProjectPopup = () => {
    setShowAddProjectPopup(true);
    setErrCreatingProject('');
  };
    const handleAddUserPopup = () => {
    setShowAddUserPopup(true);
    setErrorCreatingUser('');
  };
  const handleAddKitPopup=()=>{
    setshowAddKitPopup(true);
    setErrCreatingKit('');
  }
  const handleCancel = () => {
    setShowCorporateCard(false);
    setCorporateName('');
    setContactName('');
    setContactEmail('');
    setContactPhone('');
    setBrc('');
    setContactAddress('');
    setErrors({
      corporateName: null,
      contactName: null,
      contactEmail: null,
      contactPhone: null,
      brc: null,
      contactAddress: null,
    });
  };

  const renderCorporateForm = () => (
    <div style={{  fontFamily: "Poppins, sans-serif", }}>
      {/* Corporate Name */}
      <div style={{ marginBottom: theme.spacing.large }}>
        <label style={baseLabelStyles}>
          Corporate Name <span style={{ color: theme.colors.error }}>*</span>
        </label>
        <input
          style={{
            ...baseInputStyles,
            ...(errors.corporateName ? { borderColor: theme.colors.error } : {}),
          }}
          type="text"
          placeholder="Enter corporate name here"
          value={corporateName}
          onChange={(e) => {
            setCorporateName(e.target.value);
            setErrors({...errors, corporateName: null});
          }}
        />
        {errors.corporateName && (
          <span style={errorTextStyles}>
            {errors.corporateName}
          </span>
        )}
      </div>

      {/* Contact Name */}
      <div style={{ marginBottom: theme.spacing.large }}>
        <label style={baseLabelStyles}>
          Contact Name <span style={{ color: theme.colors.error }}>*</span>
        </label>
        <input
          style={{
            ...baseInputStyles,
            ...(errors.contactName ? { borderColor: theme.colors.error } : {}),
          }}
          type="text"
          placeholder="Enter contact name here"
          value={contactName}
          onChange={(e) => {
            setContactName(e.target.value);
            setErrors({...errors, contactName: null});
          }}
        />
        {errors.contactName && (
          <span style={errorTextStyles}>
            {errors.contactName}
          </span>
        )}
      </div>

      {/* Contact Email */}
      <div style={{ marginBottom: theme.spacing.large }}>
        <label style={baseLabelStyles}>
          Contact Email <span style={{ color: theme.colors.error }}>*</span>
        </label>
        <input
          style={{
            ...baseInputStyles,
            ...(errors.contactEmail ? { borderColor: theme.colors.error } : {}),
          }}
          type="email"
          placeholder="example@gmail.com"
          value={contactEmail}
          onChange={(e) => {
            setContactEmail(e.target.value);
            setErrors({...errors, contactEmail: null});
          }}
        />
        {errors.contactEmail && (
          <span style={errorTextStyles}>
            {errors.contactEmail}
          </span>
        )}
      </div>

      {/* Contact Phone and BRC in same row */}
      <div style={{ 
        display: "flex", 
        gap: theme.spacing.medium,
        marginBottom: theme.spacing.large
      }}>
        {/* Contact Phone */}
        <div style={{ flex: 1 }}>
          <label style={baseLabelStyles}>
            Contact Phone Number <span style={{ color: theme.colors.error }}>*</span>
          </label>
          <input
            style={{
              ...baseInputStyles,
              ...(errors.contactPhone ? { borderColor: theme.colors.error } : {}),
            }}
            type="tel"
            placeholder="eg: 07x xx xx xxx"
            value={contactPhone}
            onChange={(e) => {
              setContactPhone(e.target.value);
              setErrors({...errors, contactPhone: null});
            }}
          />
          {errors.contactPhone && (
            <span style={errorTextStyles}>
              {errors.contactPhone}
            </span>
          )}
        </div>

        {/* BRC */}
        <div style={{ flex: 1 }}>
          <label style={baseLabelStyles}>
            BRC <span style={{ color: theme.colors.error }}>*</span>
          </label>
          <input
            style={{
              ...baseInputStyles,
              fontSize: "16px",
              ...(errors.brc ? { borderColor: theme.colors.error } : {}),
            }}
            type="text"
            placeholder="Enter BRC here"
            value={brc}
            onChange={(e) => {
              setBrc(e.target.value);
              setErrors({...errors, brc: null});
            }}
          />
          {errors.brc && (
            <span style={errorTextStyles}>
              {errors.brc}
            </span>
          )}
        </div>
      </div>

      {/* Contact Address */}
      <div style={{ marginBottom: theme.spacing.large }}>
        <label style={baseLabelStyles}>
          Contact Address <span style={{ color: theme.colors.error }}>*</span>
        </label>
        <input
          style={{
            ...baseInputStyles,
            ...(errors.contactAddress ? { borderColor: theme.colors.error } : {}),
          }}
          type="text"
          placeholder="Enter contact address here"
          value={contactAddress}
          onChange={(e) => {
            setContactAddress(e.target.value);
            setErrors({...errors, contactAddress: null});
          }}
        />
        {errors.contactAddress && (
          <span style={errorTextStyles}>
            {errors.contactAddress}
          </span>
        )}
      </div>
    </div>
  );

  const renderCorporateCardView = () => (
    <div style={{ 
      fontFamily: "Poppins, sans-serif",
      width:"100%"
    }}>
      {/* Create Corporates Title */}
      <h3 style={{
        fontSize: "20px",
        fontWeight: 600,
        color: "#324054",
        marginBottom: theme.spacing.large,
        textAlign: "center",
        fontFamily: "Poppins, sans-serif",
      }}>
        Create Corporates
      </h3>

      {/* Corporate Card - Only left border */}
      <div style={cardContainer}>
  {/* Corporate Name */}
  <div style={{width:"100%",...infoBox}}>
    <div style={labelStyle}>Corporate Name</div>
    <div style={{...valueStyle, textTransform: "uppercase" }}>
      {corporateName}
    </div>
  </div>


  {/* Contact Name + Email */}
  <div style={rowContainer}>
    <div style={{width:"calc(50% - 10px)",...infoBox}}>
      <div style={labelStyle}>Contact Name</div>
      <div style={valueStyle}>
        {contactName}
      </div>
    </div>
    <div style={{width:"calc(50% - 10px)",...infoBox}}>
      <div style={labelStyle}>Contact Email</div>
      <div style={{ ...valueStyle, textTransform: "lowercase" }}>
        {contactEmail}
      </div>
    </div>
    </div>

  {/* Contact Phone + WhatsApp */}
    <div style={rowContainer}>
    <div style={{width:"calc(50% - 10px)",...infoBox}}>
      <div style={labelStyle}>Contact Phone Number</div>
      <div style={valueStyle}>
        {contactPhone}
      </div>
      </div>
    <div style={{width:"calc(50% - 10px)",...infoBox}}>
      <div style={labelStyle}>Contact Address</div>
      <div style={valueStyle}>
        {contactAddress || 'N/A'}
      </div>
    </div>
    </div>
{/* Action Buttons */}
        <div style={{
          display: "flex",
          gap: theme.spacing.small,
          flexWrap: "wrap",
          width:"100%",
          justifyContent:"space-between"
        }}>
                    <button 
            onClick={handleAddProjectPopup}
            style={{
              ...baseButtonStyles,
              backgroundColor: createdProjects.length > 0 ? "#FFFFFF" : "#2A7CED" ,
              color: createdProjects.length > 0 ? "#324054" : theme.colors.white,
              border: createdProjects.length > 0 ? "1px solid #E5E7EB" : "none",
              fontSize: "12px",
              padding: "7px 14px",
              minWidth: "auto",
              borderRadius:"4px" ,
              width:"30%"
            }}
          >
            {createdProjects.length > 0 ? `${createdProjects.length} Projects Available` : "+ Add Projects"}
          </button>
          <button 
            onClick={handleAddUserPopup}
            style={{
              ...baseButtonStyles,
              backgroundColor: createdUsers.length > 0 ? "#FFFFFF": isAddUserDisabled ? "#E2E5ED" : "#2A7CED",
              color: createdUsers.length > 0 ? "#324054" : theme.colors.white,
              border: createdUsers.length > 0 ? "1px solid #E5E7EB" : "none",
              fontSize: "12px",
              padding: "7px 14px",
              minWidth: "auto",
              borderRadius: "4px",
              width:"30%",
              cursor: isAddUserDisabled ? "not-allowed" : "pointer",
            }}
             disabled={isAddUserDisabled}
          >
            {createdUsers.length > 0 ? `${createdUsers.length} Users Available` : "+ Add Users"}
          </button>
          

          
          <button 
            onClick={handleAddKitPopup}
            style={{
              ...baseButtonStyles,
              backgroundColor: createdKits.length > 0 ? "#FFFFFF" : isAddKitDisabled ? "#E2E5ED" : "#2A7CED",
              color: createdKits.length > 0 ? "#324054" : theme.colors.white,
              border: createdKits.length > 0 ? "1px solid #E5E7EB" : "none",
              fontSize: "12px",
              padding: "7px 14px",
              minWidth: "auto",
              borderRadius: "4px",
              width:"30%",
              cursor: isAddKitDisabled ? "not-allowed" : "pointer",
            }}
            disabled={isAddKitDisabled}
          >
            {createdKits.length > 0 ? `${createdKits.length} Entities Available` : "+ Add Entities"}
          </button>
          </div>
          </div>

      {/* Navigation Buttons - Both on right side */}
      <div style={{ 
        display: "flex", 
        justifyContent: "flex-end", 
        gap: "10px", 
        marginTop: theme.spacing.large,
      }}>
        <button
          style={{ 
            ...baseButtonStyles,
            backgroundColor: theme.colors.white,
            color: theme.colors.lightText,
            border: `1px solid ${theme.colors.border}`,
            borderRadius: "4px"
          }}
          onClick={handleBack}
        >
          Back
        </button>
        
        <button
          style={{ 
            ...baseButtonStyles,
            backgroundColor: theme.colors.primary,
            color: theme.colors.white,
            border: "none",
            borderRadius: "4px"
          }}
          onClick={() => {navigate('/')}}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.backgroundColor = "#2A7CED";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.backgroundColor = "#2A7CED";
          }}
        >
          Next
        </button>
      </div>
    </div>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F9FAFB",
        padding: "16px"
      }}
    >
      {/* Logo + Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: theme.spacing.large,
        }}
      >
        <div style={theme.sizes.logoContainer}>
          <img src={polarLogo} alt="Polar Logo" style={{ width: "115%", height: "auto" }} />
        </div>
      </div>

      {/* Welcome text */}
      <div style={{ 
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection:'column',
          width:"70%",
          minWidth:"400px",
          marginBottom: theme.spacing.large,
      }}>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 600,
            color: theme.colors.text,
            lineHeight: "1.4",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <span style={{ color: theme.colors.logoSubtext, fontFamily: "Poppins, sans-serif", }}>Hello {username}!</span>{" "}
          <span style={{ color: "#324054", fontFamily: "Poppins, sans-serif", }}>Welcome to POLAR</span>
        </h2>
        <p
          style={{
            fontSize: "14px",
            fontWeight: 400,
            color: theme.colors.lightText,
            lineHeight: "1.5",
            fontFamily: "Poppins, sans-serif",
            marginTop: "7px",
            alignContent:"center"
          }}
        >
          You're just a few steps away from unlocking the full power of POLAR. Fill in your details and we'll get everything set up faster than you can say "Frosty data"!
        </p>
      </div>

      {/* Form Section */}
      <div
        style={{
          borderRadius: "12px",
          padding: "10px",
          width: "50%",
          minHeight: "469px",
          fontFamily: "Poppins, sans-serif",
          marginTop: "30px"
        }}
      >
        {showCorporateCard ? renderCorporateCardView() : (
          <>
            {renderCorporateForm()}

            {/* Form Action Buttons */}
            <div style={{ 
              display: "flex", 
              justifyContent: "flex-end",
              marginTop: theme.spacing.large,
              gap: theme.spacing.small
            }}>
              <button
                style={{ 
                  ...baseButtonStyles,
                  backgroundColor: theme.colors.primary,
                  color: theme.colors.white,
                  fontWeight: 400,
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "4px",
                }}
                onClick={handleSubmit}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = theme.colors.primaryHover;
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = theme.colors.primary;
                }}
              >
                Next
              </button>
            </div>
          </>
        )}
        
      </div>
      {showMapModal && myLoc && (
        <div
          className="modal-overlay"
          onClick={() => setShowMapModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(900px, 95vw)",
              background: "#fff",
              borderRadius: 4,
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <strong>My Location</strong>
              <button
                onClick={() => setShowMapModal(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 22,
                  lineHeight: 1,
                  cursor: "pointer",
                }}
                aria-label="Close"
                title="Close"
              >
                ×
              </button>
            </div>

            <div ref={mapRef} style={{ width: "100%", height: "60vh" }} />

            <div
              style={{
                padding: 12,
                borderTop: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
                fontSize: 12,
                color: "#666",
              }}
            >
              <span>
                Lat: {myLoc.lat.toFixed(6)}, Lng: {myLoc.lng.toFixed(6)}
              </span>
              <a
                href={`https://www.google.com/maps?q=${myLoc.lat},${myLoc.lng}`}
                target="_blank"
                rel="noreferrer"
                style={{ marginLeft: "auto" }}
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      )}
      {showAddUserPopup && (
        <AddUserPopup 
          onClose={() => setShowAddUserPopup(false)}
          onCreateUser={handleCreateUser}
          error={errCreatingUser}
        />
      )}

      {showAddProjectPopup && (
        <CreateProjectPopup 
          onClose={() => setShowAddProjectPopup(false)}
          onCreateProject={handleCreateProject}
          corporateId={corporateId}
          error={errCreatingProject}
        />
      )}

      {showAddKitPopup && (
        <AddKitModal 
          handleClose={() => setshowAddKitPopup(false)}
          onCreateKit={handleCreateKit}
          showModal={showAddKitPopup}
          setShowMapModal={setShowMapModal}
          myLoc={myLoc}
          setMyLoc={setMyLoc}
          error={errCreatingKit}
          setError={setErrCreatingKit}

        />
      )}
    </div>
  );
};

export default PolarInterface;

const cardContainer: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
};
const rowContainer: React.CSSProperties = {
width:"100%",flexDirection: "row",display: 'flex',gap:"20px"
};
const infoBox: React.CSSProperties = {
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "16px 20px",
  gap: "4px",
  background: "#FFFFFF",
  border: "1px solid #E2E5ED",
  borderRadius: "8px",
};

const labelStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#324054",
};

const valueStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#324054",
};
